import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpeedConsumptionGraphComponent } from './speed-consumption-graph.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ExpansionPanelModule } from "../../shared/components/expansion-panel/expansion-panel.module";
import { ChartModule } from 'angular-highcharts';

@NgModule({
  declarations: [SpeedConsumptionGraphComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    CustomDatePickerModule,
    CustomInputModule,
    CustomDropdownModule,
    ExpansionPanelModule,
    ChartModule
],
})
export class SpeedConsumptionGraphModule {}
